import { Controller } from '@hotwired/stimulus'

const paragraphClassNamesToToggle = ['h-6', 'overflow-hidden', 'text-ellipsis', 'whitespace-nowrap']

export default class extends Controller<HTMLDivElement> {
  static targets = ['paragraph']

  declare paragraphTarget: HTMLParagraphElement

  toggleExpansion(e: MouseEvent & { currentTarget: HTMLButtonElement | null }): void {
    paragraphClassNamesToToggle.forEach(className => {
      this.paragraphTarget.classList.toggle(className)
    })
    const buttonText = e.currentTarget?.querySelector('span > span') as HTMLSpanElement | null
    if (buttonText !== null) {
      console.log(buttonText.innerText)
      buttonText.innerText =
        'show ' + (buttonText.innerText.toLowerCase() === 'show more' ? 'less' : 'more')
    }
  }
}
